import { render, staticRenderFns } from "./UserAutomated.vue?vue&type=template&id=305c745e&"
import script from "./UserAutomated.vue?vue&type=script&lang=js&"
export * from "./UserAutomated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports